export default "__VITE_ASSET__Vsun3Ekt__"